export default "__VITE_ASSET__Cg7H239C__"